import { Link as WouterLink } from "wouter";
import style from "./Link.module.css";

// https://www.npmjs.com/package/wouter#link-hrefpath-
export default function Link(props) {
  if (!props.href) props.href = "javascript:void";

  return (
    <WouterLink
      className={style.link}
      {...props}
    >
      {props.children}
    </WouterLink>
  );
}
